<template>
  <v-card :color="color" dark width="220">
    <div class="d-flex flex-no-wrap">
      <v-avatar size="81" :color="avatarColor" tile>
        <v-icon dark class="swing">{{ icon }}</v-icon>
      </v-avatar>
      <v-divider vertical light />
      <div>
        <div class="text-subtitle-2 title ma-2">{{ title }}</div>
        <div class="text-subtitle-2 ma-2">{{ info }}</div>
        <div class="progress">
          <v-progress-linear :value="progressValue" color="white" height="2" />
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'CardResume',
  props: ['title', 'color', 'avatarColor', 'icon', 'info', 'progressValue'],
}
</script>

<style scoped>
.title {
  width: 120px;
}

@-webkit-keyframes swing {
  15% {
    -webkit-transform: rotateZ(20deg);
    transform: rotateZ(20deg);
  }
  30% {
    -webkit-transform: rotateZ(-20deg);
    transform: rotateZ(-20deg);
  }
  50% {
    -webkit-transform: rotateZ(10deg);
    transform: rotateZ(10deg);
  }
  65% {
    -webkit-transform: rotateZ(-5deg);
    transform: rotateZ(-5deg);
  }
  80% {
    -webkit-transform: rotateZ(5deg);
    transform: rotateZ(5deg);
  }
  100% {
    -webkit-transform: rotateZ(0);
    transform: rotateZ(0);
  }
}
@keyframes swing {
  15% {
    -webkit-transform: rotateZ(20deg);
    transform: rotateZ(20deg);
  }
  30% {
    -webkit-transform: rotateZ(-20deg);
    transform: rotateZ(-20deg);
  }
  50% {
    -webkit-transform: rotateZ(10deg);
    transform: rotateZ(10deg);
  }
  65% {
    -webkit-transform: rotateZ(-5deg);
    transform: rotateZ(-5deg);
  }
  80% {
    -webkit-transform: rotateZ(5deg);
    transform: rotateZ(5deg);
  }
  100% {
    -webkit-transform: rotateZ(0);
    transform: rotateZ(0);
  }
}

.swing:hover {
  -webkit-animation: swing 1s ease;
  animation: swing 1s ease;
  -webkit-animation-iteration-count: 1;
  animation-iteration-count: 1;
}
</style>
